import changeToAnalyticsFormat from "./changeToAnalyticsFormat";
import getFilterAnalytics, {
  getAnalyticsAttribute,
} from "./getFiltersAnalytics";

const getMakeModelTransportAnalytics = (appliedCheckboxes) => {
  const lastAppliedFilter = getFilterAnalytics(appliedCheckboxes);

  const previousFilters = appliedCheckboxes.slice(
    0,
    appliedCheckboxes.length - 1
  );

  let search = {
    make: "",
    model: "",
    transportEligibility: "",
    paymentStatusFilter: "",
  };
  // apply selections from previous filters to Search module
  previousFilters.forEach((item) => {
    const newValue = changeToAnalyticsFormat(item.filterKey);

    if (getAnalyticsAttribute[item.categoryKey]) {
      if (search[getAnalyticsAttribute[item.categoryKey]]?.length !== 0) {
        const previousValue = search[getAnalyticsAttribute[item.categoryKey]];
        search[
          getAnalyticsAttribute[item.categoryKey]
        ] = `${previousValue},${newValue}`;
      } else {
        search[getAnalyticsAttribute[item.categoryKey]] = newValue;
      }
    }
  });

  // apply selections from last selected filter to Search module
  if (appliedCheckboxes?.length > 0) {
    Object.keys(lastAppliedFilter).forEach((item) => {
      search[item] = lastAppliedFilter[item];
    });
  }

  return {
    make: search.make,
    model: search.model,
    transportEligibility: search.transportEligibility,
    paymentStatusFilter: search.paymentStatusFilter,
  };
};

export default getMakeModelTransportAnalytics;
